import type { ApiHttpClient } from '../client/http.client'
import type { Spoon } from '../client/spoon.client'
import type { SignInRequestData } from '../dto/auth.dto'
import { User } from '../struct/user.struct'

export class AuthApi {
  constructor(
    private http: ApiHttpClient,
    private spoon: Spoon
  ) {}

  signIn(requestData: SignInRequestData) {
    return this.http.request(
      '/signin/',
      {
        method: 'POST',
        body: requestData
      },
      User
    )
  }
}
